<template>
<div class="content_style">
    <div class="close_tab_div" @mouseover="showTabs()" @mouseout="hiddenTabs" v-show="showCloseTab" :style="closeTabHeight">
        <div class="close_text" @click="closeAllTabs('0')">关闭全部</div>
        <div class="close_text" @click="closeAllTabs('1')" v-if="!pointerEvents" :class="{'pointer_events':pointerEvents}">关闭其它页</div>
        <div class="close_text" @click="closeAllTabs('2')" v-if="!pointerEvents" :class="{'pointer_events':pointerEvents}">当前页右侧全部关闭</div>
        <div class="close_text" @click="closeAllTabs('3')" v-if="!pointerEvents" :class="{'pointer_events':pointerEvents}">当前页左侧全部关闭</div>
    </div>
    <div @contextmenu.prevent="mouseRightClick">
        <el-tabs v-model="currentCode" type="card" class="disabled_close" @tab-remove="removeTab" @tab-click="handleTabOpen">
            <el-tab-pane name="0"><span slot="label"><i class="el-icon-s-home"></i> 首页</span></el-tab-pane>
        </el-tabs>
        <el-tabs v-model="currentCode" type="card" closable @tab-remove="removeTab" @tab-click="handleTabOpen">
            <el-tab-pane v-for="item in breadList" :key="item.code" :label="item.name" :name="item.code"></el-tab-pane>
        </el-tabs>
    </div>
    <Content style="min-height: 300px;background-color: #FFFFFF;">
        <standardSysHomePage v-show="showHomePage" @showStandardPage="showStandardPage"></standardSysHomePage>
        <waitHandleCall v-if="breadName.indexOf('待回访客户')!=-1" v-show="showWaitHandleCall" @openCallPhone="openCallPhone" :pageCode="pageCode"></waitHandleCall>
        <waitRecovery v-if="breadName.indexOf('待回收客户')!=-1" v-show="showWaitRecovery" @openCallPhone="openCallPhone" :pageCode="pageCode"></waitRecovery>
        <peopleSetting v-if="showPeopleSetting" :pageCode="pageCode"></peopleSetting>
        <waitCall v-if="breadName.indexOf('待呼叫')!=-1" v-show="showWaitCall" @openCallPhone="openCallPhone" :pageCode="pageCode"></waitCall>
        <wholeCustomer v-if="showWholeCustomerPage" v-show="showWholeCustomer" :cusType="cusType" @openCallPhone="openCallPhone" :pageCode="pageCode" :breadList="breadList"></wholeCustomer>
        <publicSeaWaterCustomer v-if="breadName.indexOf('公海客户')!=-1" v-show="showPublicSeaWaterCustomer" @openCallPhone="openCallPhone" :pageCode="pageCode"></publicSeaWaterCustomer>
        <deletedCustomer v-if="breadName.indexOf('已删除客户')!=-1" v-show="showDeletedCustomer" @openCallPhone="openCallPhone" :pageCode="pageCode"></deletedCustomer>
        <serviceRecord v-if="breadName.indexOf('服务记录')!=-1" v-show="showServiceRecord" @openCallPhone="openCallPhone" :pageCode="pageCode"></serviceRecord>
        <customSetup v-if="breadName.indexOf('自定义设置')!=-1" v-show="showCustomSetup" :pageCode="pageCode"></customSetup>
        <operationLog v-if="breadName.indexOf('操作日志')!=-1" v-show="showOperationLog" :pageCode="pageCode"></operationLog>
        <BandWlist v-if="breadName.indexOf('黑白名单')!=-1" v-show="showblackandwhite" :pageCode="pageCode"></BandWlist>
        <basicConfig v-if="breadName.indexOf('基本配置')!=-1" v-show="showBasicConfig" :seaSetList="seaSetList" :pageCode="pageCode"></basicConfig>
        <cascadeConfig v-if="breadName.indexOf('级联数据设置')!=-1 && showCascadeConfig" :pageCode="pageCode"></cascadeConfig>
        <timeDefinition v-if="breadName.indexOf('时间定义')!=-1" v-show="showTimeDefinition" :pageCode="pageCode"></timeDefinition>
        <batchImport v-if="breadName.indexOf('导入批次')!=-1" v-show="showBatchImport" :pageCode="pageCode"></batchImport>
        <downLoadTask v-if="breadName.indexOf('导出批次')!=-1" v-show="showDownLoadTask" :pageCode="pageCode"></downLoadTask>
        <pstnNumberTable v-if="breadName.indexOf('热线号码')!=-1" v-show="showPstnNumberTable" :pageCode="pageCode"></pstnNumberTable>
        <skillsGroup v-if="breadName.indexOf('技能组')!=-1 && showSkillsGroup" :pageCode="pageCode"></skillsGroup>
        <IVRTable v-if="breadName.indexOf('IVR设置')!=-1" @updateShowDetail="updateShowDetail" v-show="showIVR" :pageCode="pageCode"></IVRTable>
        <voiceFile v-if="breadName.indexOf('语音文件')!=-1" v-show="showVoiceFile" :pageCode="pageCode"></voiceFile>
        <membershipMange v-if="breadName.indexOf('VIP管理')!=-1" v-show="showMembershipMange" :pageCode="pageCode"></membershipMange>
        <powerSetting v-if="breadName.indexOf('角色管理')!=-1 && showPowerSetting" :pageCode="pageCode"></powerSetting>
        <departmentManage v-if="breadName.indexOf('部门管理')!=-1" v-show="showDepartmentManage" :pageCode="pageCode"></departmentManage>
        <MailList v-if="breadName.indexOf('通讯录')!=-1" v-show="showmaillist" @openCallPhone="openCallPhone" :pageCode="pageCode"></MailList>
        <ChannelManage v-if="breadName.indexOf('渠道管理')!=-1" v-show="showChannelManage" :pageCode="pageCode"></ChannelManage>
        <Blacklist v-if="breadName.indexOf('黑名单')!=-1" v-show="showBlacklist" :pageCode="pageCode"></Blacklist>
        <NavigationMenu v-if="breadName.indexOf('导航菜单')!=-1" v-show="showMenu" :pageCode="pageCode"></NavigationMenu>
        <agentListing v-if="breadName.indexOf('员工管理')!=-1 && showAgentListing" @openCallPhone="openCallPhone" :pageCode="pageCode" @showStandardPage="showStandardPage"></agentListing>
        <telephoneScreen v-show="showTelephoneScreen" v-if="telephoneCount > 0" ref="phoneScreen" :currentCallData="currentCallData" @openCallPhone="openCallPhone" @closeTelephoneScreen="closeTelephoneScreen" @showStandardPage="showStandardPage" :reserve="reserve"></telephoneScreen>
        <callOutPlan v-if="breadName.indexOf('呼出任务')!=-1" v-show="showCallOutPlan" :pageCode="pageCode" @openCallPhone="openCallPhone"></callOutPlan>
        <callOutMonitor v-if="breadName.indexOf('呼出监控')!=-1" v-show="showCallOutMonitor" :pageCode="pageCode"></callOutMonitor>
        <knowledgeBaseType v-if="breadName.indexOf('知识总览')!=-1" v-show="showKnowledgeBaseType" :pageCode="pageCode" @showStandardPage="showStandardPage"></knowledgeBaseType>
        <viewknowContent v-if="showViewknowContent" :knowLookId="knowLookId"></viewknowContent>

        <callRecord v-if="breadName.indexOf('通话记录')!=-1" v-show="showCallRecord" @closeVn="closeVn" @openVn="openVn" @openCallPhone="openCallPhone" :pageCode="pageCode"></callRecord>
        <statusChangeDetail v-if="breadName.indexOf('状态变化明细')!=-1" v-show="showStatusChangeDetail" @closeVn="closeVn" @openVn="openVn" :pageCode="pageCode"></statusChangeDetail>
        <voiceMessage v-if="breadName.indexOf('语音留言')!=-1" v-show="showVoiceMessage" @closeVn="closeVn" @openVn="openVn" :pageCode="pageCode" @openCallPhone="openCallPhone"></voiceMessage>
        <satisfactionDetail v-if="breadName.indexOf('满意度明细')!=-1" v-show="showSatisfactionDetail" @closeVn="closeVn" @openVn="openVn" @openCallPhone="openCallPhone" :pageCode="pageCode"></satisfactionDetail>
        <missedCallDetail v-if="breadName.indexOf('未接来电')!=-1" v-show="showMissedCallDetail" @closeVn="closeVn" @openVn="openVn" @openCallPhone="openCallPhone" :pageCode="pageCode"></missedCallDetail>
        <InsideLineDetail v-if="breadName.indexOf('内线通话明细')!=-1" v-show="showInsideLineDetail" @closeVn="closeVn" @openVn="openVn" @openCallPhone="openCallPhone" :pageCode="pageCode"></InsideLineDetail>
        <officeCall v-if="breadName.indexOf('办公话单')!=-1" v-show="showOfficeCall" @closeVn="closeVn" @openVn="openVn" @openCallPhone="openCallPhone" :pageCode="pageCode"></officeCall>
        <SessionDetail v-if="breadName.indexOf('会话明细')!=-1" v-show="showSessionDetail" @closeVn="closeVn" @openVn="openVn"  :pageCode="pageCode"></SessionDetail>
        <ConverMessage v-if="breadName.indexOf('会话留言')!=-1" v-show="showConverMessage" @closeVn="closeVn" @openVn="openVn" @openCallPhone="openCallPhone" :pageCode="pageCode"></ConverMessage>

        <callOverview v-if="breadName.indexOf('通话总览')!=-1" v-show="showCallOverview" @closeVn="closeVn" @openVn="openVn" :pageCode="pageCode"></callOverview>
        <departCallTotal v-if="breadName.indexOf('部门通话统计')!=-1" v-show="showDepartCallTotal" @closeVn="closeVn" @openVn="openVn" :pageCode="pageCode"></departCallTotal>
        <IVRTotal v-if="breadName.indexOf('IVR统计')!=-1" v-show="showIVRTotal" @closeVn="closeVn" @openVn="openVn" :pageCode="pageCode" @openCallPhone="openCallPhone"></IVRTotal>
        <pstnNumberTotal v-if="breadName.indexOf('热线号码统计')!=-1" v-show="showPstnNumberTotal" @closeVn="closeVn" @openVn="openVn" :pageCode="pageCode"></pstnNumberTotal>
        <satisfactionDegreeTotal v-if="breadName.indexOf('满意度统计')!=-1" v-show="showSatisfactionDegreeTotal" @closeVn="closeVn" @openVn="openVn" :pageCode="pageCode"></satisfactionDegreeTotal>
        <seatCallTotal v-if="breadName.indexOf('座席通话统计')!=-1" v-show="showSeatCallTotal" @closeVn="closeVn" @openVn="openVn" :pageCode="pageCode"></seatCallTotal>
        <skillsGroupCallTotal v-if="breadName.indexOf('技能组通话统计')!=-1" v-show="showSkillsGroupCallTotal" @closeVn="closeVn" @openVn="openVn" :pageCode="pageCode"></skillsGroupCallTotal>
        <messageRecord v-if="breadName.indexOf('短信记录')!=-1" v-show="showMessageRecord" @openCallPhone="openCallPhone" :pageCode="pageCode"></messageRecord>
        <messageSend v-if="breadName.indexOf('短信发送')!=-1" v-show="showMessageSend" :pageCode="pageCode"></messageSend>
        <messageTemplate v-if="breadName.indexOf('短信模板')!=-1" v-show="showMessageTemplate" :pageCode="pageCode"></messageTemplate>
        <currentCall v-if="breadName.indexOf('当前通话')!=-1" v-show="showCurrentCall" @openCallPhone="openCallPhone" :pageCode="pageCode"></currentCall>
        <overview v-if="breadName.indexOf('总览')!=-1" v-show="showOverview" :pageCode="pageCode"></overview>
        <seatMonitor v-if="breadName.indexOf('座席监控')!=-1" v-show="showSeatMonitor" @getSeat="getSeat" ref="contentSeat" :pageCode="pageCode"></seatMonitor>
        <skillGroupMonitor v-if="breadName.indexOf('技能组监控')!=-1" v-show="showSkillGroupMonitor" @getSkill="getSkill" ref="contentSkill" :pageCode="pageCode"></skillGroupMonitor>
        <seatCallPicture v-if="breadName.indexOf('座席通话量')!=-1" v-show="showSeatCallPicture" :pageCode="pageCode"></seatCallPicture>
        <skillsGroupCallPicture v-if="breadName.indexOf('技能组通话量')!=-1" v-show="showSkillsGroupCallPicture" :pageCode="pageCode"></skillsGroupCallPicture>
        <departCallPicture v-if="breadName.indexOf('部门通话量')!=-1" v-show="showDepartCallPicture" :pageCode="pageCode"></departCallPicture>
        <satisfactionDegreePicture v-if="breadName.indexOf('满意度评价')!=-1" v-show="showSatisfactionDegreePicture" :pageCode="pageCode"></satisfactionDegreePicture>


        <callAllView v-if="showCallAllView" :pageCode="pageCode"></callAllView>
        <AgentWorkplace v-if="showAgentWorkplace" :pageCode="pageCode"></AgentWorkplace>
        <OnlineService v-if="breadName.indexOf('在线客服')!=-1" v-show="showservice" :showservice="showservice" :client="client" @openCallPhone="openCallPhone" :pageCode="pageCode" @showStandardPage="showStandardPage"></OnlineService>
        <signalpage v-if="breadName.indexOf('网络延迟')!=-1" v-show="showsignalpage" :pageCode="pageCode"></signalpage>
        <AIFlowListing v-if="breadName.indexOf('AI流程设置')!=-1" v-show="showAIFlowListing" :pageCode="pageCode" @showStandardPage="showStandardPage" @openTips="showTips"></AIFlowListing>
        <AICall v-if="breadName.indexOf('AI呼叫管理')!=-1" v-show="showAICall" :pageCode="pageCode"></AICall>
        <AIQueue v-if="breadName.indexOf('AI技能组')!=-1" v-show="showAIQueue" :pageCode="pageCode"></AIQueue>
        <AICallRecordListing v-if="breadName.indexOf('AI通话记录')!=-1" v-show="showAICallListing" @closeVn="closeVn" @openVn="openVn" @openCallPhone="openCallPhone" :pageCode="pageCode"></AICallRecordListing>
        <workspace v-show="showFlowDraw" ref="flowDraw" :pageCode="pageCode"></workspace>
        <closeTips :show="showCloseTips" :openTips="newOpenTips" @closeTips="closeTipsFunction" @closeAction="closeAction"></closeTips>
        <thirdPopPage v-show="showThirdPopPage" :pageCode="pageCode" :thirdPopupAddressList="thirdPopupAddressList"></thirdPopPage>
        <talkCountReport v-if="breadName.indexOf('交互轮次统计')!=-1" v-show="showTalkCount" @closeVn="closeVn" @openVn="openVn('AIREPORT')" :pageCode="pageCode"></talkCountReport>
        <callQualityReport v-if="breadName.indexOf('呼出质量统计')!=-1" v-show="showCallQuality" @closeVn="closeVn" @openVn="openVn('AIREPORT')" :pageCode="pageCode"></callQualityReport>
        <focusReport v-if="breadName.indexOf('关注点统计')!=-1" v-show="showFocus" @closeVn="closeVn" @openVn="openVn('AIREPORT')" :pageCode="pageCode"></focusReport>
        <aiTagReport v-if="breadName.indexOf('分类标签统计')!=-1" v-show="showAITag" @closeVn="closeVn" @openVn="openVn('AIREPORT')" :pageCode="pageCode"></aiTagReport>
        <webPage v-show="showwebPage" :pageCode="pageCode" :quickApplyList="quickApplyList"></webPage>
        <NotpushedBill  v-if="breadName.indexOf('未推送话单')!=-1" v-show="showNotpushedBill" @openCallPhone="openCallPhone" :pageCode="pageCode" @closeVn="closeVn" @openVn="openVn"></NotpushedBill>
        <paramConfig v-if="breadName.indexOf('参数配置')!=-1 && showParamConfig" @closeVn="closeVn" @openVn="openVn"></paramConfig>
        <ReplyMenu v-if="breadName.indexOf('快捷回复')!=-1" v-show="showReplyMenu" :pageCode="pageCode"></ReplyMenu>
        <Flowtrigger v-if="showFlowtrigger"></Flowtrigger>
        <ServiceGroup v-if="breadName.indexOf('工单服务组')!=-1" v-show="showServiceGroup" :pageCode="pageCode"> </ServiceGroup>
        <WorkOrderExtensionForm v-if="breadName.indexOf('工单扩展表单')!=-1" v-show="showExtensionForm" :pageCode="pageCode"> </WorkOrderExtensionForm>
        <NewWorkOrder v-if="workOrderCount > 0" v-show="showNewWorkOrder" ref="newWorkOrder" :addWorkOrderFlag="addWorkOrderFlag" @openCallPhone="openCallPhone" :orderId="orderId" :workReserve="workReserve" :pageCode="pageCode" @closeFlowEdit="closeFlowEdit" @updateWorkOrderTabName="updateWorkOrderTabName"></NewWorkOrder>
        <WorkOrderConfig v-if="breadName.indexOf('工单参数配置')!=-1" v-show="showWorkOrderConfig" :pageCode="pageCode"></WorkOrderConfig>
        <SlaPage v-if="showSla"></SlaPage>
        <AllWorkOrders v-show="showAllWorkOrders" @showStandardPage="showStandardPage" :pageCode="pageCode" :orderCode="orderCode" @openCallPhone="openCallPhone"></AllWorkOrders>
        <UndoneOrder v-if="breadName.indexOf('未完成工单监控')!=-1" v-show="showUndoneOrder" @showStandardPage="showStandardPage" :pageCode="pageCode"></UndoneOrder>
        <AgentWorkloadStatistics v-if="breadName.indexOf('客服工作量统计')!=-1" v-show="showAgentWorkload" @closeVn="closeVn" @openVn="openVn" :pageCode="pageCode"></AgentWorkloadStatistics>
        <WorkOrderTypeStatistics v-if="breadName.indexOf('工单类型统计')!=-1" v-show="showWorkOrderType" @closeVn="closeVn" @openVn="openVn" :pageCode="pageCode"></WorkOrderTypeStatistics>
        <SlaServiceLevelStatistics v-if="breadName.indexOf('SLA服务等级统计')!=-1" v-show="showSlaServiceLevel" @closeVn="closeVn" @openVn="openVn" :pageCode="pageCode"></SlaServiceLevelStatistics>
        <notice v-show="showNotice" v-if="breadName.indexOf('公告管理')!=-1" @noticeShow="noticeShow" :showNotice="showNotice" :pageCode="pageCode"></notice>
    </Content>
</div>
</template>

<script>
import standardSysHomePage from '@/components/login/StandardSysHomePage.vue'
import waitHandleCall from '@/components/myWorkbench/WaitHandleCall.vue'
import waitRecovery from '@/components/myWorkbench/WaitRecovery.vue'
import peopleSetting from '@/components/myWorkbench/PeopleSetting.vue'
import waitCall from '@/components/myWorkbench/WaitCall.vue'
import wholeCustomer from '@/components/customerMange/WholeCustomer.vue'
import publicSeaWaterCustomer from '@/components/customerMange/PublicSeaWaterCustomer.vue'
import deletedCustomer from '@/components/customerMange/DeletedCustomer.vue'
import serviceRecord from '@/components/customerMange/ServiceRecord.vue'
import customSetup from '@/components/systemSetup/customSetup.vue'
import operationLog from '@/components/systemSetup/OperationLog.vue'
import BandWlist from '@/components/systemSetup/BandWlist.vue'
import basicConfig from '@/components/systemSetup/BasicConfig.vue'
import cascadeConfig from '@/components/systemSetup/CascadeConfig.vue'
import timeDefinition from '@/components/systemSetup/TimeDefinition.vue'
import batchImport from '@/components/systemSetup/BatchImport.vue'
import downLoadTask from '@/components/systemSetup/DownLoadTask.vue'
import pstnNumberTable from '@/components/systemSetup/CTIConfigure/PstnNumberTable.vue'
import ChannelManage from '@/components/systemSetup/DialogueConfigure/ChannelManage.vue'
import Blacklist from '@/components/systemSetup/DialogueConfigure/Blacklist.vue'
import NavigationMenu from '@/components/systemSetup/DialogueConfigure/NavigationMenu.vue'
import skillsGroup from '@/components/systemSetup/CTIConfigure/SkillsGroup.vue'
import IVRTable from '@/components/systemSetup/CTIConfigure/IVRTable.vue'
import voiceFile from '@/components/systemSetup/CTIConfigure/VoiceFile.vue'
import membershipMange from '@/components/systemSetup/CTIConfigure/MembershipMange.vue'
import powerSetting from '@/components/userManagement/PowerSetting.vue'
import departmentManage from '@/components/userManagement/DepartmentManage.vue'
import MailList from '@/components/userManagement/MailList.vue'
import agentListing from '@/components/agentManage/AgentListing.vue'
import telephoneScreen from '@/components/loginHeadMange/TelephoneScreen.vue'
import callOutPlan from '@/components/callManage/CallOutPlan.vue'
import callOutMonitor from '@/components/callManage/CallOutMonitor.vue'
import knowledgeBaseType from '@/components/knowledgeBase/KnowledgeBaseType.vue'
import viewknowContent from '@/components/knowledgeBase/ViewknowContent.vue'
import callRecord from '@/components/statisticsReportForm/detailedReportForm/CallRecord.vue'
import statusChangeDetail from '@/components/statisticsReportForm/detailedReportForm/StatusChangeDetail.vue'
import voiceMessage from '@/components/statisticsReportForm/detailedReportForm/VoiceMessage.vue'
import SessionDetail from '@/components/statisticsReportForm/detailedReportForm/SessionDetail.vue'
import ConverMessage from '@/components/statisticsReportForm/detailedReportForm/ConverMessage.vue'
import satisfactionDetail from '@/components/statisticsReportForm/detailedReportForm/SatisfactionDetail.vue'
import missedCallDetail from '@/components/statisticsReportForm/detailedReportForm/MissedCallDetail.vue'
import InsideLineDetail from '@/components/statisticsReportForm/detailedReportForm/InsideLineDetail.vue'
import officeCall from '@/components/statisticsReportForm/detailedReportForm/OfficeCall.vue'
import callOverview from '@/components/statisticsReportForm/CallStatistics/CallOverview.vue'
import departCallTotal from '@/components/statisticsReportForm/CallStatistics/DepartCallTotal.vue'
import IVRTotal from '@/components/statisticsReportForm/CallStatistics/IVRTotal.vue'
import pstnNumberTotal from '@/components/statisticsReportForm/CallStatistics/PstnNumberTotal.vue'
import satisfactionDegreeTotal from '@/components/statisticsReportForm/CallStatistics/SatisfactionDegreeTotal.vue'
import seatCallTotal from '@/components/statisticsReportForm/CallStatistics/SeatCallTotal.vue'
import skillsGroupCallTotal from '@/components/statisticsReportForm/CallStatistics/SkillsGroupCallTotal.vue'
import seatCallPicture from '@/components/statisticsReportForm/PictureReportForm/SeatCallPicture.vue'
import skillsGroupCallPicture from '@/components/statisticsReportForm/PictureReportForm/SkillsGroupCallPicture.vue'
import departCallPicture from '@/components/statisticsReportForm/PictureReportForm/DepartCallPicture.vue'
import satisfactionDegreePicture from '@/components/statisticsReportForm/PictureReportForm/SatisfactionDegreePicture.vue'
import notice from '@/components/userManagement/Notice.vue'

import messageRecord from '@/components/MessageManage/MessageRecord.vue'
import messageSend from '@/components/MessageManage/MessageSend.vue'
import messageTemplate from '@/components/MessageManage/MessageTemplate.vue'
import currentCall from '@/components/MonitorManage/CurrentCall.vue'
import overview from '@/components/MonitorManage/Overview.vue'
import seatMonitor from '@/components/MonitorManage/SeatMonitor.vue'
import skillGroupMonitor from '@/components/MonitorManage/SkillGroupMonitor.vue'
import callAllView from '@/components/bigScreen/CallAllView.vue'
import AgentWorkplace from '@/components/bigScreen/AgentWorkplace.vue'
import OnlineService  from '@/components/OnlineService/OnlineService.vue'
import signalpage from '@/components/myWorkbench/signalpage.vue'
import AIFlowListing from "@/components/aiManager/AIFlowListing";
import AICall from "@/components/aiManager/AICall";
import AIQueue from "@/components/aiManager/AIQueue";
import Workspace from "../flow/workspace";
import AICallRecordListing from "../aiManager/AICallRecordListing";
import CloseTips from "../flow/closeTips";
import eventBus from "../../util/eventBus";
import thirdPopPage from '@/components/loginHeadMange/ThirdPopPage.vue';
import talkCountReport from '@/components/statisticsReportForm/AIReportForm/TalkCountReport.vue'
import callQualityReport from '@/components/statisticsReportForm/AIReportForm/CallQualityReport.vue'
import focusReport from '@/components/statisticsReportForm/AIReportForm/FocusReport.vue'
import aiTagReport from '@/components/statisticsReportForm/AIReportForm/AITagReport.vue'
import webPage from '@/components/fastApplication/webPage.vue'
import NotpushedBill from '@/components/statisticsReportForm/detailedReportForm/NotpushedBill.vue'
import paramConfig from '@/components/systemSetup/paramConfig.vue'
import ReplyMenu  from '@/components/systemSetup/DialogueConfigure/ReplyMenu.vue'
import Flowtrigger  from '@/components/systemSetup/worknote/FlowTrigger.vue'
import ServiceGroup from'@/components/systemSetup/worknote/ServiceGroup.vue'
import NewWorkOrder from '@/components/workOrder/NewWorkOrder.vue'
import WorkOrderConfig from '@/components/systemSetup/worknote/WorkOrderConfig.vue'
import SlaPage from '@/components/systemSetup/worknote/SlaPage.vue'
import AllWorkOrders from '@/components/workOrder/AllWorkOrders.vue'
import WorkOrderExtensionForm from'@/components/systemSetup/worknote/WorkOrderExtensionForm.vue'
import UndoneOrder from '@/components/MonitorManage/UndoneOrder.vue'
import AgentWorkloadStatistics from '@/components/statisticsReportForm/workOrderReportForm/AgentWorkloadStatistics.vue'
import SlaServiceLevelStatistics from '@/components/statisticsReportForm/workOrderReportForm/SlaServiceLevelStatistics.vue'
import WorkOrderTypeStatistics from '@/components/statisticsReportForm/workOrderReportForm/WorkOrderTypeStatistics.vue'


export default {
    name: "StandardSysContent",
    props: {
        isCollapsed: Boolean
    },
    components: {
        CloseTips,
        Workspace,
        seatCallPicture,
        skillsGroupCallPicture,
        departCallPicture,
        satisfactionDegreePicture,
        currentCall,
        overview,
        seatMonitor,
        skillGroupMonitor,
        messageRecord,
        messageSend,
        messageTemplate,
        callOverview,
        departCallTotal,
        IVRTotal,
        pstnNumberTotal,
        satisfactionDegreeTotal,
        seatCallTotal,
        skillsGroupCallTotal,
        callRecord,
        statusChangeDetail,
        voiceMessage,
        SessionDetail,
        ConverMessage,
        satisfactionDetail,
        missedCallDetail,
        InsideLineDetail,
        officeCall,
        standardSysHomePage,
        waitHandleCall,
        waitRecovery,
        peopleSetting,
        waitCall,
        wholeCustomer,
        publicSeaWaterCustomer,
        deletedCustomer,
        serviceRecord,
        customSetup,
        operationLog,
        powerSetting,
        departmentManage,
        MailList,
        agentListing,
        BandWlist,
        basicConfig,
        cascadeConfig,
        timeDefinition,
        batchImport,
        downLoadTask,
        pstnNumberTable,
        ChannelManage,
        Blacklist,
        NavigationMenu,
        skillsGroup,
        IVRTable,
        voiceFile,
        membershipMange,
        telephoneScreen,
        callOutPlan,
        callOutMonitor,
        knowledgeBaseType,
        callAllView,
        AgentWorkplace,
        viewknowContent,
        OnlineService,
        signalpage,
        notice,
        //add ai page
        AIQueue,
        AICall,
        AIFlowListing,
        AICallRecordListing,
        // 三方弹屏
        thirdPopPage,
        //AI报表
        talkCountReport,
        callQualityReport,
        focusReport,
        aiTagReport,
        webPage,
        NotpushedBill,
        paramConfig,
        ReplyMenu,
        Flowtrigger, //流程触发器
        ServiceGroup,//工单服务组
        WorkOrderExtensionForm,//工单扩展表单
        NewWorkOrder,
        SlaPage, //SLA界面
        WorkOrderConfig,
        AllWorkOrders,
        // 未完成工单监控
        UndoneOrder,
        AgentWorkloadStatistics,
        SlaServiceLevelStatistics,
        WorkOrderTypeStatistics,
    },
    data() {
        return {
            isShowDetail:false,
            client:'',
            pageCode: '0',
            contentSeat: '',
            phoneScreen: '',
            contentSkill: '',
            showCloseTab: false,
            pointerEvents: true,
            rightId: '',
            closeTabHeight: {
                left: '',
                top: ''
            },
            breadName: "",
            breadList: [],
            editableTabsValue: '',
            message: '',
            reserve: null,
            currentCallData: "",
            addWorkOrderFlag:"",
            workReserve:null,
            editableTabs: [{
                title: 'Tab 1',
                name: '1',
                content: 'Tab 1 content'
            }, {
                title: 'Tab 2',
                name: '2',
                content: 'Tab 2 content'
            }],
            cusType: '',
            currentCode: '0',
            deleteCode: '',
            seaSetList: JSON.parse(localStorage.getItem("customerType")),
            showHomePage: true,
            showWaitHandleCall: false,
            showWaitRecovery: false,
            showWaitCall: false,
            showPeopleSetting: false,
            showWholeCustomer: false,
            showWholeCustomerPage: false,
            showPublicSeaWaterCustomer: false,
            showDeletedCustomer: false,
            showServiceRecord: false,
            showCustomSetup:false,
            showOperationLog: false,
            showPowerSetting: false,
            showDepartmentManage: false,
            showmaillist:false,
            showAgentListing: false,
            showblackandwhite:false,
            showBasicConfig: false,
            showCascadeConfig: false,
            showTimeDefinition: false,
            showBatchImport: false,
            showDownLoadTask: false,
            showPstnNumberTable: false,
            showChannelManage:false,
            showReplyMenu:false,
            showBlacklist:false,
            showMenu:false,
            showSkillsGroup: false,
            showIVR: false,
            showVoiceFile: false,
            showMembershipMange: false,
            showTelephoneScreen: false,
            currentCallPhone: "0",
            changeTabName: true,
            showCallOutPlan: false,
            showCallOutMonitor: false,
            showKnowledgeBaseType: false,
            showViewknowContent: false,
            knowLookId: '',
            showCallRecord: false,
            showStatusChangeDetail: false,
            showVoiceMessage: false,
            showSatisfactionDetail: false,
            showMissedCallDetail: false,
            showInsideLineDetail: false,
            showOfficeCall: false,
            showConverMessage:false,
            showSessionDetail:false,
            showCallOverview: false,
            showDepartCallTotal: false,
            showIVRTotal: false,
            showPstnNumberTotal: false,
            showSatisfactionDegreeTotal: false,
            showSeatCallTotal: false,
            showSkillsGroupCallTotal: false,
            showMessageRecord: false,
            showMessageSend: false,
            showMessageTemplate: false,
            showCurrentCall: false,
            showOverview: false,
            showSeatMonitor: false,
            showSkillGroupMonitor: false,
            showSeatCallPicture: false,
            showSkillsGroupCallPicture: false,
            showDepartCallPicture: false,
            showSatisfactionDegreePicture: false,
            showNotice:false,//公告管理

            showCallAllView: false,
            showAgentWorkplace: false,
            showservice:false,
            showsignalpage: false,
            //add ai
            showAIFlowListing: false,
            showAIQueue: false,
            showAICall: false,
            showFlowDraw: false,
            showAICallListing: false,
            showCloseTips: false,
            newOpenTips: undefined,
            flowItem: undefined,
            configInfo: JSON.parse(localStorage.getItem("configInfo")),
            thirdPopupAddress: localStorage.getItem("thirdPopupAddress"),
            // 三方弹屏
            showThirdPopPage:false,
            //AI报表
            showTalkCount:false,
            showCallQuality:false,
            showFocus:false,
            showAITag:false,
            showwebPage:false,
            showNotpushedBill:false,
            quickApplyList:JSON.parse(localStorage.getItem("quickApply")),
            thirdPopupAddressList:[],
            showParamConfig: false, //参数配置
            telephoneCount: 1, //当前弹屏数量，默认为1,
            showFlowtrigger: false, //流程触发器
            showServiceGroup: false,//工单服务组
            showExtensionForm:false,
            showNewWorkOrder:false,
            showWorkOrderConfig:false,
            showAllWorkOrders:false,
            showSla: false, //sla界面
            workOrderCount:1,
            orderId:'',
            showUndoneOrder: false, //未完成工单监控
            orderCode:'',  //工单的标识
            showAgentWorkload:false,//客服工作量统计
            showSlaServiceLevel:false,//sla服务等级
            showWorkOrderType:false,//工单类型统计
        }
    },
    methods: {
        noticeShow:function(item){
          this.$emit("noticeShow",item);
        },
        monitorListData: function (event) {
            event = JSON.parse(event);
            this.$refs.contentSkill.monitorSkillData(event);
        },
        seatMonitorData: function (event) {
            event = JSON.parse(event);
            this.$refs.contentSeat.monitorSeatData(event);
        },
        getSeat: function (arg, key, value) {
          // 去重
          let val = "";
          value.split(',').forEach(item =>{
            if(val.indexOf(item+",") == -1){
              val += (item+",");
            }
          });

          this.$emit("getSeatAndSkill", arg, key, val.substring(0,val.lastIndexOf(',')));
        },
        getSkill: function (arg, key, value) {
          let val = "";
          value.split(',').forEach(item =>{
            if(val.indexOf(item+",") == -1){
              val += (item+",");
            }
          });
            this.$emit("getSeatAndSkill", arg, key, val.substring(0,val.lastIndexOf(',')));
        },
        openVn: function (arg) {
            this.closeVn();
            let message = '(请点击【查询】按钮加载数据)'
            if (arg) {
              if (arg === 'AIREPORT') {
                message = '(请先选择流程，再点击【查询】按钮加载数据)'
              }
            }
            const h = this.$createElement;
            this.message = this.$message({
                duration: 10000,
                showClose: true,
                customClass: "search_title",
                message: h('p', null, [
                    h('span', null, ''),
                    h('span', {
                        style: 'color: red'
                    }, message)
                ])
            });
        },
        closeVn: function () {
            if (this.message) {
                this.message.close();
            }
        },
        mouseRightClick: function (event) {
            this.showCloseTab = true;
            let clientX = event.clientX;
            let offsetY = event.offsetY;
            this.pointerEvents = false;
            let id = event.target.id.substring(4, event.target.id.length);
            if (!id) {
                this.pointerEvents = true;
            }
            this.rightId = id;
            if (this.isCollapsed) {
                this.closeTabHeight.left = clientX - 65 + "px";
            } else {
                this.closeTabHeight.left = clientX - 200 + "px";
            }
            this.closeTabHeight.top = offsetY + "px";
        },
        showTabs: function () {
            this.showCloseTab = true;
        },
        hiddenTabs: function () {
            this.showCloseTab = false;
        },
        clearWorkOrder:function(){
          //将标签页中的工单删除
          this.$store.commit('clearWorkOrderData');
          this.workOrderCount = this.$store.getters.getWorkOrderCount();
          //这里一定要将workOrderCount字段再初始化为1，否则再次打开不显示
          if(this.workOrderCount == 0){
            let that = this;
            setTimeout(function(){
              that.workOrderCount = 1;
            },200);
          }
        },
        closeAllTabs: function (sign) {
            this.showCloseTab = false;
            let flow = undefined;
            let flowOne = "";
            if (sign == "0") {
                //判断是否含有流程编辑
                flow = this.closeTips(this.breadList, 'a_2-8')
                flowOne = this.closeTips(this.breadList, '3_5-3')
                if (flow) {
                    this.breadList = []
                    this.breadList.push(flow)
                    if(flowOne && this.isShowDetail){
                      this.breadList.push(flowOne)
                    }
                    this.newOpenTips = false
                    this.showCloseTips = true
                    this.showStandardPage(flow.code + "," + flow.name + "," + flow.agentUuid)
                    return false
                }
                if (flowOne && this.isShowDetail) {
                  this.breadList = []
                  this.breadList.push(flowOne);
                  this.showStandardPage(flowOne.code + "," + flowOne.name + "," + flowOne.agentUuid)
                  this.$confirm('关闭页面后，未保存数据将无法找回，是否继续？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }).then(() => {
                    this.closeFlowEdit('3_5-3');
                    this.isShowDetail = false;
                  }).catch(() => {
                  })
                  return false;
                }
                this.breadList = [];
                this.showStandardPage("0,首页");
                this.showCloseTab = false;
                this.clearWorkOrder();
                return false;
            }
            let index = 0;
            let tabName = "";
            let agentUuid = '';
            for (let i = 0; i < this.breadList.length; i++) {
                let code = this.breadList[i].code;
                let name = this.breadList[i].name;
                let newAgentUuid = this.breadList[i].agentUuid;
                if (this.rightId == code) {
                    index = i;
                    tabName = name;
                    agentUuid = newAgentUuid;
                }
            }
            if (sign == "1") { //关闭其他页
                this.breadList = [];

                //判断是否含有流程编辑
                flow = this.closeTips(this.breadList, 'a_2-8')
                if (flow) {
                    this.breadList.push(flow)
                    this.newOpenTips = false
                    this.showCloseTips = true
                }
            }
            let pre = undefined
            if (sign == "2") { //关闭右侧 ,右侧有在最后插入
                let tempList = this.breadList.slice(index, this.breadList.length)
                flow = this.closeTips(tempList, 'a_2-8')
                this.breadList = this.breadList.slice(0, index);
                if (flow) {
                    //this.breadList.push(flow)
                    this.newOpenTips = false
                    this.showCloseTips = true
                    pre = 'push'
                }
            }
            if (sign == "3") { //关闭左侧
                let tempList = this.breadList.slice(0, index)
                flow = this.closeTips(tempList, 'a_2-8')
                this.breadList = this.breadList.slice(index, this.breadList.length);
                if (flow) {
                    //this.breadList.unshift(flow)
                    this.newOpenTips = false
                    this.showCloseTips = true
                    pre = 'unshift'
                }
            }
            let breadCount = 0;
            let breadContent=[];
            for (let i = 0; i < this.breadList.length; i++) {
              let breadCode = this.breadList[i].code;
              if (breadCode.indexOf('b_w_1') != -1) {
                breadCount++;
                breadContent.push(breadCode);
              }
            }
            if(breadCount > 0){
              this.$store.commit('cutWorkOrderData',breadContent);
            }else{
              this.clearWorkOrder();
            }
            this.showStandardPage(this.rightId + "," + tabName + "," + agentUuid);
            if (pre === 'push') {
                this.breadList.push(flow)
            } else if (pre === 'unshift') {
                this.breadList.unshift(flow)
            }
        },
        openCallPhone: function (flag, phone, sign, cusData) {
            this.$emit("callTelephone", true, phone, sign, cusData);
        },
        closeTelephoneScreen: function (phone) {
            for (let i = 0; i < this.breadList.length; i++) {
                let code = this.breadList[i].code;
                let name = this.breadList[i].name;
                if (name == phone) {
                  this.removeTab(code);
                }
            }
        },
        changePage: function () {
            this.showHomePage = false;
            this.showWaitHandleCall = false;
            this.showWaitRecovery = false;
            this.showWaitCall = false;
            this.showPeopleSetting = false;
            this.showWholeCustomer = false;
            this.showPublicSeaWaterCustomer = false;
            this.showDeletedCustomer = false;
            this.showServiceRecord = false;
            this.showCustomSetup=false;
            this.showOperationLog = false;
            this.showPowerSetting = false;
            this.showDepartmentManage = false;
            this.showmaillist=false;
            this.showAgentListing = false;
            this.showblackandwhite=false;
            this.showBasicConfig = false;
            this.showTimeDefinition = false;
            this.showBatchImport = false;
            this.showDownLoadTask = false;
            this.showCascadeConfig = false;
            this.showPstnNumberTable = false;
            this.showChannelManage=false;
            this.showReplyMenu=false;
            this.showMenu=false;
            this.showBlacklist=false;
            this.showSkillsGroup = false;
            this.showIVR = false;
            this.showVoiceFile = false;
            this.showMembershipMange = false;
            this.showTelephoneScreen = false;
            this.showCallOutPlan = false;
            this.showCallOutMonitor = false;
            this.showKnowledgeBaseType = false;
            this.showViewknowContent = false;
            this.showCallRecord = false;
            this.showStatusChangeDetail = false;
            this.showVoiceMessage = false;
            this.showSatisfactionDetail = false;
            this.showMissedCallDetail = false;
            this.showInsideLineDetail = false;
            this.showOfficeCall = false;
            this.showConverMessage=false;
            this.showSessionDetail=false;
            this.showCallOverview = false;
            this.showDepartCallTotal = false;
            this.showIVRTotal = false;
            this.showPstnNumberTotal = false;
            this.showSatisfactionDegreeTotal = false;
            this.showSeatCallTotal = false;
            this.showSkillsGroupCallTotal = false;
            this.showMessageRecord = false;
            this.showMessageSend = false;
            this.showMessageTemplate = false;
            this.showCurrentCall = false;
            this.showOverview = false;
            this.showSeatMonitor = false;
            this.showSkillGroupMonitor = false;
            this.showSeatCallPicture = false;
            this.showSkillsGroupCallPicture = false;
            this.showDepartCallPicture = false;
            this.showSatisfactionDegreePicture = false;

            this.showCallAllView = false;
            this.showAgentWorkplace = false;
            this.showservice=false;
            this.showsignalpage = false;
            this.showAIFlowListing = false;
            this.showAICall = false;
            this.showAIQueue = false;
            this.showFlowDraw = false;
            this.showAICallListing = false;
            this.showThirdPopPage = false;
            this.showTalkCount = false;
            this.showCallQuality = false;
            this.showFocus = false;
            this.showAITag = false;
            this.showwebPage=false;
            this.showNotpushedBill=false;
            this.showParamConfig = false;
            this.showFlowtrigger = false;
            this.showServiceGroup =false;
            this.showExtensionForm=false;
            this.showNewWorkOrder=false;
            this.showWorkOrderConfig=false;
            this.showSla=false;
            this.showAllWorkOrders=false;
            this.showUndoneOrder = false;
            this.showAgentWorkload = false;
            this.showSlaServiceLevel = false;
            this.showWorkOrderType = false;
            this.showNotice = false;
        },
        // obj格式：code,name   reserve格式：JsonObject
        showStandardPage: function (obj, reserve,fromWhere) {
            let code = obj.split(",")[0];
            // 如果配置了第三方弹屏链接，则使用第三方弹屏
            if (this.thirdPopupAddress && code.indexOf('third_pop_') == -1 && code.indexOf("pop_") != -1) {

                let popPhone = reserve.callPhone; //取第四个值，弹屏号码(未加密)
                if (!popPhone) {
                    popPhone = "电话弹屏";
                }

                if(this.thirdPopupAddress.indexOf('http') == -1){  //没有带http，https
                    if(window.location.protocol.indexOf('https') > -1){
                       this.thirdPopupAddress = "https://"+this.thirdPopupAddress;
                    }else{
                      this.thirdPopupAddress = "http://"+this.thirdPopupAddress;
                    }
                }

                // 参数顺序：弹屏号码(未加密)、员工工号、企业编号、通话唯一标识，采集号码、热线号码
                let param = "phone="+popPhone+"&agentno="+reserve.agentNumber+"&companyno="+reserve.companyCode+"&call_uuid="+reserve.callUuid
                            + "&collectNum="+reserve.reserve+ "&callcenterNum="+reserve.callcenterNum;

                let params = {
                    address: this.thirdPopupAddress + "?"+param,
                    isShow: true,
                    id: "third_pop_"+popPhone
                }
                this.thirdPopupAddressList.push(params);
                this.showStandardPage("third_pop_"+popPhone+","+popPhone);
                console.info("三方弹屏的链接地址："+this.thirdPopupAddress);
                console.info("三方弹屏的链接地址的参数列表params："+JSON.stringify(params));
                return false;
            }
            this.changePage();
            this.changeTabName = false;
            this.closeVn();
            if (code != "0") {
                this.modifyBread(obj);
            } else {
                if(!this.breadList || this.breadList == 0){
                  this.breadName = [];
                }
                this.currentCode = "0";
                this.showHomePage = true;
                return false;
            }
            let breadName = [];
            let breadCount = 0;
            for (let i = 0; i < this.breadList.length; i++) {
                let breadCode = this.breadList[i].code;
                if (breadCode.indexOf('1_2') != -1) {
                    breadCount++;
                }
                breadName.push(this.breadList[i].name)
            }
            localStorage.setItem("breadList", JSON.stringify(this.breadList));
            this.breadName = breadName.toString();
            if (breadCount == 0) {
                this.showWholeCustomerPage = false;
            } else {
                this.showWholeCustomerPage = true;
            }

            switch(code){
                case '0':  //首页
                  this.showHomePage = true;
                  break;
                case '1_3':  //公海客户
                  this.showPublicSeaWaterCustomer = true;
                  break;
                case '1_5':  //服务记录
                  this.showServiceRecord = true;
                  break;
                case '2_2':  //外呼计划
                  this.showCallOutPlan = true;
                  break;
                case '2_3':  //外呼监控
                  this.showCallOutMonitor = true;
                  break;
                case '3_2':
                this.showCustomSetup = true;
                break;
                case '3_12-1':
                  this.showChannelManage=true;
                  break;
                case '3_12-2':
                  this.showBlacklist=true;
                  break;
                case '3_12-3':
                  this.showMenu=true;
                  break;
               case '3_12-4':
                  this.showReplyMenu=true;
                  break;
                case '3_11':
                  this.showblackandwhite= true;
                  break;
                case '3_3':    //基本配置
                  this.showBasicConfig = true;
                  break;
                case '3_4':  //操作日志
                  this.showOperationLog = true;
                  break;
                case '3_5-1':
                  this.showPstnNumberTable = true;
                  break;
                case '3_5-2':
                  this.showSkillsGroup = true;
                  break;
                case '3_5-3':
                  this.showIVR = true;
                  break;
                case '3_5-4':
                  this.showVoiceFile = true;
                  break;
                case '3_5-5':
                  this.showMembershipMange = true;
                  break;
                case '3_6':
                  this.showTimeDefinition = true;
                  break;
                case '3_7':
                  this.showBatchImport = true;
                  break;
                case '3_8':
                  this.showDownLoadTask = true;
                  break;
                case '3_9':
                  this.showCascadeConfig = true;
                  break;
                case '3_10':
                  this.showDeletedCustomer = true;
                  break;
                case '4_2':
                  this.showWaitHandleCall = true;
                  break;
                case '4_3':
                  this.showWaitRecovery = true;
                  break;
                case '4_5':
                  this.showWaitCall = true;
                  break;
                case '4_4':
                  this.showPeopleSetting = true;
                  break;
                case '5_2':
                  this.showMessageSend = true;
                  break;
                case '5_3':
                  this.showMessageTemplate = true;
                  break;
                case '5_4':
                  this.showMessageRecord = true;
                  break;
                case '6_2':
                  this.showKnowledgeBaseType = true;
                  break;
                case '7_2-1':
                  this.showCurrentCall = true;
                  break;
                case '7_2-2':
                  this.showOverview = true;
                  break;
                case '7_2-3':
                  this.showSkillGroupMonitor = true;
                  break;
                case '7_2-4':
                  this.showSeatMonitor = true;
                  break;
                case '8_2-1':
                  this.showCallRecord = true;
                  break;
                case '8_2-2':
                  this.showStatusChangeDetail = true;
                  break;
                case '8_2-3':
                  this.showSatisfactionDetail = true;
                  break;
                case '8_2-4':
                  this.showMissedCallDetail = true;
                  break;
                case '8_2-5':
                  this.showInsideLineDetail = true;
                  break;
                case '8_2-6':
                  this.showOfficeCall = true;
                  break;
                case '8_2-7':
                  this.showVoiceMessage = true;
                  break;
               case '8_2-8':
                  this.showNotpushedBill = true;
                  break;
                case '8_2-9':
                  this.showSessionDetail = true;
                  break;
                case '8_2-10':
                  this.showConverMessage = true;
                  break;

                case '8_3-1':
                  this.showCallOverview = true;
                  break;
                case '8_3-2':
                  this.showPstnNumberTotal = true;
                  break;
                case '8_3-3':
                  this.showSeatCallTotal = true;
                  break;
                case '8_3-4':
                  this.showSkillsGroupCallTotal = true;
                  break;
                case '8_3-5':
                  this.showDepartCallTotal = true;
                  break;
                case '8_3-6':
                  this.showIVRTotal = true;
                  break;
                case '8_3-7':
                  this.showSatisfactionDegreeTotal = true;
                  break;
                case '8_4-1':
                  this.showSeatCallPicture = true;
                  break;
                case '8_4-2':
                  this.showSkillsGroupCallPicture = true;
                  break;
                case '8_4-3':
                  this.showDepartCallPicture = true;
                  break;
                case '8_4-4':
                  this.showSatisfactionDegreePicture = true;
                  break;

                case '8_5-1':
                  this.showCallAllView = true;
                  break;
                case '8_5-2':
                  this.showAgentWorkplace = true;
                  break;
                case '8_6-1':
                  this.showTalkCount = true;
                  break;
                case '8_6-2':
                  this.showCallQuality = true;
                  break;
                case '8_6-3':
                  this.showFocus = true;
                  break;
                case '8_6-4':
                  this.showAITag = true;
                  break;
                case '9_2':
                  this.showPowerSetting = true;
                  break;
                case '9_3':
                  this.showAgentListing = true;
                  break;
                case '9_4':
                  this.showDepartmentManage = true;
                  break;
                case '9_5':
                  this.showmaillist = true;
                  break;
                case '9_6':
                  this.showNotice = true;
                  break;
                case 'signal':
                  this.showsignalpage = true;
                  break;
                case 'a_2':
                  this.showAIFlowListing = true;
                  break;
                case 'a_2-8':
                  this.showFlowDraw = true;
                  break;

                case 'a_3':
                  this.showAICall = true;
                  break;
                case 'a_4':
                  this.showAIQueue = true;
                  break;
                case 'a_5':
                  this.showAICallListing = true;
                  break;
                case 'online':
                  this.showservice = true;
                  break;
                case '3_12-5':
                  this.showParamConfig = true;
                  break;
                case '3_d-3':
                  this.showFlowtrigger = true;
                  break;
                case '3_d-4':
                  this.showSla = true;
                  break;
                case '3_d-1':
                  this.showServiceGroup = true;
                  break;
                case '3_d-2':
                  this.showExtensionForm = true;
                  break;
                case '3_d-5':
                  this.showWorkOrderConfig = true;
                  break;
                case 'b_2': //所有工单
                  this.showAllWorkOrders = true;
                  break;
                case 'b_3': //我的未完成工单
                  this.showAllWorkOrders = true;
                  break;
                case 'b_4': //待我确认的工单
                  this.showAllWorkOrders = true;
                  break;
                case 'b_5': //抄送给我的工单
                  this.showAllWorkOrders = true;
                  break;
                case 'b_6': //我创建的工单
                  this.showAllWorkOrders = true;
                  break;
                case 'b_7': //未分配的工单
                  this.showAllWorkOrders = true;
                  break;
                case 'b_8': //已分配的工单
                  this.showAllWorkOrders = true;
                  break;
                case 'b_9': //处理中的工单
                  this.showAllWorkOrders = true;
                  break;
                case 'b_a': //暂停的工单
                  this.showAllWorkOrders = true;
                  break;
                case 'b_b': //已完成的工单
                  this.showAllWorkOrders = true;
                  break;
                case 'b_c': //已关闭的工单
                  this.showAllWorkOrders = true;
                  break;
                case 'b_d': //回收站
                  this.showAllWorkOrders = true;
                  break;
                case '7_3':  //未完成工单监控
                  this.showUndoneOrder = true;
                  break;
                case '8_7-2':  //客服工作量统计
                  this.showAgentWorkload = true;
                  break;
                case '8_7-3':  //工单类型统计
                  this.showWorkOrderType = true;
                  break;
                case '8_7-5':  //Sla服务等级统计
                  this.showSlaServiceLevel = true;
                  break;
            }
            if (code.indexOf('1_2') != -1) {
                this.cusType = "-1";
                if (code.indexOf("/") != -1) {
                    let customerType = code.split("/")[1];
                    this.cusType = customerType;
                }
                this.showWholeCustomer = true;
            } else {
                this.cusType = "-2";
            }
            // 弹屏,将把reserve整体传过去
            if (code.indexOf("pop_") != -1 && code.indexOf("third_pop_") == -1) {
                this.currentCallData = obj;
                this.changeTabName = true;
                this.reserve = reserve;
                let that = this;
                // 延迟500毫秒显示，为了防止短时间打开页面空白
                setTimeout(function(){
                  that.showTelephoneScreen = true;
                },500)
            }
            if (code.indexOf("b_w_1") != -1) {
              this.showNewWorkOrder = true;
              this.addWorkOrderFlag = obj+","+Math.random();
              this.workReserve = reserve;
              this.orderId = "";
              if(code.indexOf("-") != -1){
                this.orderId = code.split("-")[1];
              }
            }
            if (code.indexOf('10_') != -1) {
                this.showwebPage = true;
            }
            if (code.indexOf('6_3') != -1) {
              if (reserve) {
                this.knowLookId = reserve + '';
              }
              this.showViewknowContent = true;
            }
            if (this.thirdPopupAddress && code.indexOf('third_pop_') != -1) {
                this.showThirdPopPage = true;
            }
            if (code.indexOf('third_pop_') > -1 ) {  //三方弹屏
                this.showThirdPopPage = true
            }
            // 工单共用界面使用
            this.orderCode = code;
            let that = this;
            setTimeout(function () {
                that.pageCode = code;
            }, 100);
        },
        //每次点击面包屑页签的动作
        handleTabOpen: function () {
            if (this.currentCode == "0") {
                this.showStandardPage("0,首页");
                return false;
            }
            // 知识库相关
            for (let i = 0; i < this.breadList.length; i++) {
                let code = this.breadList[i].code;
                let name = this.breadList[i].name;
                let agentUuid = this.breadList[i].agentUuid ? this.breadList[i].agentUuid : "";
                let pid = ''
                if (this.currentCode == code) {
                    //add last id
                    if (code.indexOf('6_3') != -1 ) {
                        pid = code.split("-")[1];
                    }else{
                        pid = null;
                    }
                    this.showStandardPage(code + "," + name + "," + agentUuid, pid);
                }
            }
        },
        removeTab(targetName) {
            //过滤流程绘制
            if (targetName.indexOf("a_2-8") != '-1') {
                this.newOpenTips = false
                this.showCloseTips = true
                return
            }
            if (targetName.indexOf("1_2") != "-1") {
                let cacheCustomerList = JSON.parse(localStorage.getItem("cacheCustomerList"));
                if (targetName == '1_2') {
                    cacheCustomerList["-1"] = "";
                } else {
                    if (targetName.indexOf("/") != -1) {
                        let type = targetName.split("/")[1];
                        cacheCustomerList[type] = "";
                    }
                }
                localStorage.setItem("cacheCustomerList", JSON.stringify(cacheCustomerList));
            }
          if (targetName.indexOf("3_5-3") != '-1' && this.isShowDetail) {
            this.$confirm('关闭页面后，未保存数据将无法找回，是否继续？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.closeFlowEdit('3_5-3');
              this.isShowDetail = false;
            }).catch(() => {
            })
            return false;
          }
            let tabs = this.breadList;
            let activeName = this.currentCode;
            if (activeName === targetName) {
                tabs.forEach((tab, index) => {
                    if (tab.code === targetName) {
                        let nextTab = tabs[index + 1] || tabs[index - 1];
                        if (nextTab) {
                            activeName = nextTab.code;
                        }
                    }
                });
            }
            this.currentCode = activeName;


            // 清除弹屏数据

            if(targetName.indexOf("pop_") !=-1 ){
                this.$store.commit('delTelephoneData',targetName);
                this.telephoneCount = this.$store.getters.getTelephoneCount();
                //这里一定要将telephoneCount字段再初始化为1，否则再次打开不显示
                if(this.telephoneCount == 0){
                  let that = this;
                  setTimeout(function(){
                    that.telephoneCount = 1;
                  },500); //延迟500毫秒，且在打开弹屏时延迟500毫秒
                }
            }
            //工单
            if(targetName.indexOf("b_w_1") !=-1 ){
              this.$store.commit('delWorkOrderData',targetName);
              this.workOrderCount = this.$store.getters.getWorkOrderCount();
              //这里一定要将workOrderCount字段再初始化为1，否则再次打开不显示
              if(this.workOrderCount <= 0){
                let that = this;
                setTimeout(function(){
                  that.workOrderCount = 1;
                },1000);
              }
            }
            // 工单列表数据清除
            if(targetName.indexOf('b_') > -1){
              let cacheOrderList = JSON.parse(localStorage.getItem("cacheOrderList"));
                delete cacheOrderList[targetName];
                localStorage.setItem("cacheOrderList", JSON.stringify(cacheOrderList));
            }

            this.breadList = tabs.filter(tab => tab.code !== targetName);
            if (this.breadList.length == 0) {
                this.currentCode = "0";
            }
            this.handleTabOpen();

            if(targetName.indexOf("10_") != -1){
                let that = this;
                // 将关闭的webpage销毁
                for(let i = 0; i < this.quickApplyList.length; i++){
                    if(targetName == this.quickApplyList[i].id){
                        this.quickApplyList[i].isShow = false;
                    }
                }
                //这里一定要将isShow字段再初始化为true，否则再次打开不显示
                //而且必须要延迟一会才可以，否则会导致组件销毁不了
                setTimeout(function(){
                    // 将销毁后的数据还原
                    for(let i = 0; i < that.quickApplyList.length; i++){
                        if(targetName == that.quickApplyList[i].id){
                            that.quickApplyList[i].isShow = true;
                        }
                    }
                },1000);
            }
            // 三方弹屏
            if(targetName.indexOf("third_pop_") != -1){
                let that = this;
                // 将关闭的webpage销毁
                for(let i = 0; i < this.thirdPopupAddressList.length; i++){
                    if(targetName == this.thirdPopupAddressList[i].id){
                        this.thirdPopupAddressList[i].isShow = false;
                        that.thirdPopupAddressList.splice(i,1);
                    }
                }
            }
            this.pageCode = this.currentCode;
            this.orderCode = this.currentCode;

        },
        closeFlowEdit(targetName) {
            let tabs = this.breadList;
            let activeName = this.currentCode;
            if (activeName === targetName) {
                tabs.forEach((tab, index) => {
                    if (tab.code === targetName) {
                        let nextTab = tabs[index + 1] || tabs[index - 1];
                        if (nextTab) {
                            activeName = nextTab.code;
                        }
                    }
                });
            }
            this.currentCode = activeName;

            if (targetName < 0) {
                for (let i = 0; i < this.breadList.length; i++) {
                    if (this.breadList[i].code == targetName) {
                        this.currentCallPhone = "0";
                        this.$refs.phoneScreen.clearTelephoneScreenList(this.breadList[i].name);
                    }
                }
            }
            this.breadList = tabs.filter(tab => tab.code !== targetName);
            if (this.breadList.length == 0) {
                this.currentCode = "0";
            }
            this.handleTabOpen();
        },
        modifyBread: function (obj) {
            let code = obj.split(",")[0];
            let name = obj.split(",")[1];
            let agentUuid = obj.split(",")[2];

            let param = {
                name: name,
                code: code,
              agentUuid:agentUuid
            };
            this.currentCode = code;
            let index = this.breadList.findIndex(item => item.code === code);
            if(index == -1){  //没有菜单push
                this.breadList.push(param);
            }

        },
        showTips(value, item) {
            //判断是否是打开
            if (value) {
                let hasOpen = false
                for (let i = 0; i < this.breadList.length; i++) {
                    let item = this.breadList[i]
                    if (!item.hasOwnProperty('code')) {
                        hasOpen = false
                        break
                    }
                    let code = item['code'];
                    if (code === 'a_2-8') {
                        hasOpen = true
                        break
                    }
                }
                if (hasOpen) {
                    this.showCloseTips = true
                    this.newOpenTips = true
                } else {
                    this.showCloseTips = false
                    //直接打开
                    eventBus.$emit('openEditFlow', true, item)
                }
                this.flowItem = item
            }
        },
        closeTips(breadArray, targetName) {
            if (!Array.isArray(breadArray) || breadArray.length <= 0) {
                return null
            }
            for (let i = 0; i < breadArray.length; i++) {
                let item = breadArray[i]
                if (!item.hasOwnProperty('code')) {
                    return null
                }
                let code = item['code'];
                if (code === targetName) {
                    //阻止关闭流程
                    return item
                }
            }
            return null
        },
        closeTipsFunction(value) {
            this.showCloseTips = false
            delete this.newOpenTips
            this.newOpenTips = undefined
        },
        closeAction(save, open, action) {
            //打开
            if (action) {
                eventBus.$emit('saveFlow', save)
                eventBus.$emit('openEditFlow', open, this.flowItem)
            } else {
                eventBus.$emit('saveFlow', save)
                if (open) {
                    this.closeFlowEdit('a_2-8')
                }
            }
            delete this.flowItem
            this.flowItem = undefined
        },
        updateShowDetail:function(flag){
          this.isShowDetail = flag;
        },
        //通过pageCode修改工单标签页名
        updateWorkOrderTabName:function (val,id,pageCode) {
          let newCode = 'b_w_1-'+id;
          for (let i = 0; i < this.breadList.length; i++) {
            let code = this.breadList[i].code;
            if (pageCode == code) {
              this.breadList[i].name = val;
              let param = {
                oldUuId:code,
                newUuId:newCode
              };
              if(this.currentCode == code){
                this.currentCode = newCode;
              }
              this.$store.commit('updateWorkOrderData',param);
              this.breadList[i].code = newCode;
              this.$forceUpdate();
            }
          }
        }
    },
}
</script>

<style lang="less">
.pointer_events {
    cursor: not-allowed !important;
    pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/login/StandardSysContent.vue